import React from 'react';

export interface RequiredProxyInputProps {
  // true cuando el campo ya tiene valor: el testigo deja de estar vacío y el submit pasa.
  filled: boolean;
  disabled?: boolean;
}

// PLA-1099: testigo para que un control no nativo participe de la validación del navegador.
//
// Hace falta porque `react-select` 5.2.1 NO implementa el prop `required` (soporte agregado en
// 5.3.0): pasárselo no hace nada, así que un `<Select>` obligatorio dejaba enviar el formulario
// vacío y el error sólo aparecía al volver del servidor. Lo mismo pasa con la tabla de calidades,
// que son checkboxes sueltos.
//
// El input va vacío mientras el campo no tenga valor, de modo que el `required` nativo bloquea el
// envío y el navegador muestra su burbuja junto al control.
//
// NO se oculta con `display:none` ni `visibility:hidden` a propósito: un control inválido que no
// se puede enfocar hace que Chrome aborte la validación y registre en consola "An invalid form
// control ... is not focusable". Con `opacity: 0` el elemento sigue en el layout y es enfocable.
// Por eso el contenedor de cada consumidor es `position: relative`.
const proxyStyle: React.CSSProperties = {
  position: 'absolute',
  left: 0,
  bottom: 0,
  width: '100%',
  height: '1px',
  padding: 0,
  border: 0,
  opacity: 0,
};

const RequiredProxyInput = ({ filled, disabled = false }: RequiredProxyInputProps) => (
  <input
    type='text'
    // Sin `name` no viaja en el submit: es sólo un testigo de validación.
    tabIndex={-1}
    autoComplete='off'
    aria-hidden='true'
    required
    disabled={disabled}
    value={filled ? 'filled' : ''}
    onChange={() => undefined}
    style={proxyStyle}
  />
);

export default RequiredProxyInput;
